export const STATICKEYS = {
    rerender: 1,
    clearSelection: 2,
    selectedKey: 3,
    selectedRoster: 4,
    organizationId: 5,
    testViewLoading: 6,
    viewTestClicked: 7
};

export default class StaticProperties {

    static instance;
    private items = new Map();
    private eventsNotifier: any;

    constructor() {
        this.items.set(STATICKEYS.rerender, false);
        this.items.set(STATICKEYS.clearSelection, false);
        this.items.set(STATICKEYS.selectedKey, '');
        this.items.set(STATICKEYS.selectedRoster, '');
        this.items.set(STATICKEYS.organizationId, '');
        this.items.set(STATICKEYS.testViewLoading, '');
        this.items.set(STATICKEYS.viewTestClicked, '');
        this.eventsNotifier = new Map();
    }

    get(itemKey: any) {
        if (this.items.has(itemKey)) {
            return this.items.get(itemKey);
        }
        return '';
    }

    set(itemKey: any, itemValue: any) {
        if (this.items.has(itemKey)) {
            let oldValue = this.items.get(itemKey);
            this.items.set(itemKey, itemValue);
            if ( oldValue !== itemValue) {
                this.eventsNotifier.forEach((notifyKeyChange: any, key: any) => {
                    notifyKeyChange(itemKey, itemValue);
                });
            }
        }
    }

    addEventListener( name: string, notifyKeyChange: any) {
        this.eventsNotifier.set( name, notifyKeyChange  );
    }
    
}

export let staticProperties = new StaticProperties();


// WEBPACK FOOTER //
// ./src/components/common/staticProperties.tsx